module.exports = __webpack_public_path__ + "img/other.626b7071.png";